import { render, staticRenderFns } from "./BusinessStatsTab.vue?vue&type=template&id=47521192&"
import script from "./BusinessStatsTab.vue?vue&type=script&lang=js&"
export * from "./BusinessStatsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports